import adminApi from "../../api";

class AdminProductService {
  async getAllProducts() {
    const response = await adminApi.get("/products");
    return response.data;
  }

  async createProduct(formData) {
    const response = await adminApi.post("/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async updateProduct(id, productData) {
    let headers = {};
    if (productData instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }

    const response = await adminApi.put(`/products/${id}`, productData, {
      headers,
    });
    return response.data;
  }

  async deleteProduct(id) {
    const response = await adminApi.delete(`/products/${id}`);
    return response.data;
  }
}

export default new AdminProductService();
